import React from 'react';

type Props = {
  /** Use 'onlight' on light backgrounds (e.g. the login page); default suits dark backgrounds. */
  variant?: 'default' | 'onlight';
  className?: string;
  /** Rendered height in px. Width scales automatically. */
  height?: number;
};

const BrandLogo: React.FC<Props> = ({ variant = 'default', className, height = 30 }) => (
  <img
    src={variant === 'onlight' ? '/viralai-logo-onlight.svg' : '/viralai-logo.svg'}
    alt="VimAPI — A ViralAI Platform"
    className={className}
    style={{ height, width: 'auto', display: 'block' }}
  />
);

export default BrandLogo;
